module.exports = __webpack_public_path__ + "media/application/images/icons/dont-buy-8c2892fc83e20bd12cf2881890bd57e2.svg";